import React, { Component } from "react";
import AppContext from "../../../contexts/AppContext";
import {Link } from "react-router-dom";
import style from "../checkout.css";
import Login from "../../auth/Login";
import Reset from "../../auth/password/Reset";


export class CheckoutHeader extends Component {
    state = { 
        login: false,
		resetPassword: false,
		isToggleOn: false,
    };
    componentDidMount() {   

    };
	
	handleClick = () => {
		this.setState({ isToggleOn: this.state.isToggleOn === true ? false : true })
	};
    
    toggleLogin = () => {
        if(this.context.state.isAuth())
        {
            this.setState({ wregister:false, login: false });
            window.location = '/account';
        }
        else{
            this.setState({ wregister:false, login: this.state.login === true ? false : true });
        }
        
    };
	
	toggleResetPassword = () => {
        this.setState({ login:false, resetPassword: this.state.resetPassword === true ? false : true });
    };
	
	hideAll = () => {
        this.setState({ login: false });
    };

    render() {
        return (
            <section className="checkout-header mb-0">
			    <div className="container">
				    <nav className="navbar navbar-expand-md justify-content-between border-0 p-0">
                        <Link className="navbar-brand" to="/"><img src="/images/logo_w.png"  width="161" height="34"  alt="logo"/></Link>
                        <button className="navbar-toggler" type="button" onClick={() => this.handleClick()}>
                            <img src="/images/Icon-menu.svg" alt="menu"/>
                        </button>
                        <div className={this.state.isToggleOn ? 'collapse navbar-collapse d-block' : 'collapse navbar-collapse'}>
                            <ul className="navbar-nav m-0">
                                <li className="nav-item">
                                    <span className="text-white mr-2">{this.context.state.isAuth() ? `Go to account?` : `Returning customer?`}</span>
							        <button className="border-0 rounded-0 p-0 m-0 font-weight-bold" onClick={ this.toggleLogin }>{this.context.state.isAuth() ? `Account` : `Click here to log in.`}</button>
                                </li>
                            </ul>
                        </div>  
                    </nav>
					{this.state.login === true ? <Login toggleResetPassword={this.toggleResetPassword} toggleLogin={this.toggleLogin}></Login> : ""}
				    {this.state.resetPassword === true ? <Reset toggleResetPassword={this.toggleResetPassword}></Reset> : ""}
				</div>
			</section>
		);
    }
}

CheckoutHeader.contextType = AppContext;
export default CheckoutHeader;



// WEBPACK FOOTER //
// ./src/components/general/include/CheckoutHeader.js